// @flow
import styled from 'styled-components';
import { jetBlack, cleanWhite } from '../../colors';
import { ReactComponent as ArrowRight } from '../../static-icons/arrow-right.svg';
/*::
import type { Node } from 'react';
import type { StyledComponent } from 'styled-components';

export type SimpleCardThemeType = {
  Main: StyledComponent<{}, mixed, HTMLDivElement>
    | React$ComponentType<{}>,
  Gradient: StyledComponent<{}, mixed, HTMLDivElement>
    | React$ComponentType<{}>,
  Text: StyledComponent<{}, mixed, HTMLLinkElement>
    | React$ComponentType<{}>,
  TextWrapper: StyledComponent<{}, mixed, HTMLHeadingElement>
    | React$ComponentType<{}>,
  Link: StyledComponent<{}, mixed, HTMLLinkElement>
    | React$ComponentType<{}>,
  Arrow: StyledComponent<{}, mixed, HTMLImageElement>
    | React$ComponentType<{}>,
}
*/

var SimpleCardTheme
/*: SimpleCardThemeType */
= {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "s0meib-0"
  })(["position:relative;overflow:hidden;border-radius:1.2rem;width:32.8rem;height:52.8rem;& > *:first-child{width:32.8rem;height:52.8rem;}"]),
  Gradient: styled.div.withConfig({
    displayName: "theme__Gradient",
    componentId: "s0meib-1"
  })(["position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient( to bottom,rgba(0,0,0,0),rgba(0,0,0,0) 42%,", ");"], jetBlack()),
  Text: styled.a.withConfig({
    displayName: "theme__Text",
    componentId: "s0meib-2"
  })(["text-decoration:none;font-size:3.6rem;color:", ";"], cleanWhite()),
  TextWrapper: styled.h3.withConfig({
    displayName: "theme__TextWrapper",
    componentId: "s0meib-3"
  })(["position:absolute;bottom:6.5rem;left:2.4rem;right:2.4rem;margin:0;text-decoration:none;font-weight:200;font-size:3.6rem;color:", ";"], cleanWhite()),
  Link: styled.a.withConfig({
    displayName: "theme__Link",
    componentId: "s0meib-4"
  })(["position:absolute;bottom:2.7rem;left:2.4rem;padding:0 3.1rem 0 0;font-size:1.7rem;color:", ";"], cleanWhite()),
  Arrow: styled(ArrowRight).withConfig({
    displayName: "theme__Arrow",
    componentId: "s0meib-5"
  })(["position:absolute;right:0;bottom:0;width:1.71rem;fill:", ";"], cleanWhite())
};
export default SimpleCardTheme;